import { ITaskListItem, TaskListItem } from "../task/taskListItem";
import { Base } from "ui/Scripts/source/framework/base";

export interface IFrontPageTask {
    tasks: ITaskListItem[];
    canCreateTasks: boolean;
}

export class FrontPageTask implements IFrontPageTask {
    tasks: TaskListItem[];
    canCreateTasks: boolean;

    constructor();
    constructor(obj: IFrontPageTask);
    constructor(obj?: any) {
        this.tasks = Base.getTypedArray(obj ? obj.tasks : null, TaskListItem);
        this.canCreateTasks = obj && obj.canCreateTasks || false;
    }
}